/* eslint-disable react/prop-types */
import { FaFacebook, FaTelegram, FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { AiFillYoutube } from "react-icons/ai";
import { IoMailOutline, IoLocationOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Image } from "@heroui/react";
import axios from "axios";
import { useEffect, useState } from "react";

const Footer = ({ homePageData }) => {
  const [metaDescription, setMetaDescription] = useState("");
  const [footerData, setFooterData] = useState([]);
  const apiUrl = import.meta.env.VITE_APP_API;
  const organizationData = homePageData?.organization;

  // Update document title, favicon, and meta description
  useEffect(() => {
    if (organizationData?.title) {
      document.title = organizationData.title;
    }

    if (organizationData?.description) {
      const plainText = organizationData.description.replace(/<\/?p>/g, ""); // Remove <p> tags
      setMetaDescription(plainText);
    }

    if (organizationData?.logo) {
      const faviconLink = document.querySelector("link[rel='icon']");
      if (faviconLink) {
        faviconLink.href = `${apiUrl}${organizationData.logo}`;
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = `${apiUrl}${organizationData.logo}`;
        document.head.appendChild(newLink);
      }
    }
  }, [organizationData, apiUrl]);

  // Update meta description in the document head
  useEffect(() => {
    if (metaDescription) {
      let metaTag = document.querySelector('meta[name="description"]');
      if (metaTag) {
        metaTag.content = metaDescription;
      } else {
        metaTag = document.createElement("meta");
        metaTag.name = "description";
        metaTag.content = metaDescription;
        document.head.appendChild(metaTag);
      }
    }
  }, [metaDescription]);

  // Fetch footer data
  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/account/footer/`);
        const sortedFooterData = response.data.results.sort(
          (a, b) => a.serial - b.serial
        );
        setFooterData(sortedFooterData);
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };
    fetchFooterData();
  }, [apiUrl]);
  console.log(organizationData, "organizationData");

  return (
    <footer className="w-screen px-2 sm:px-0 mx-auto pt-5 border-t bg-[#532356]">
      <div className="container">
        <div className="lg:flex py-10">
          {/* Logo & Social Media Links */}
          <div className="w-full lg:w-2/5 flex flex-col items-center justify-center">
            {organizationData?.logo && (
              <Link to="/">
                <Image
                  className="h-16 w-auto rounded-none bg-white"
                  src={`${apiUrl}${organizationData.logo}`}
                  alt="logo"
                />
              </Link>
            )}

            <div className="flex mt-6 -mx-2 items-center">
              {organizationData?.facebook && (
                <a
                  href={organizationData.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-2 text-white hover:text-blue-500"
                >
                  <FaFacebook size={28} />
                </a>
              )}
              {organizationData?.insta && (
                <a
                  href={organizationData.insta}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-2 text-white hover:text-pink-500"
                >
                  <img
                    src="https://cdn2.iconfinder.com/data/icons/facebook-51/32/FACEBOOK-11-512.png"
                    alt="Instagram"
                    className="w-[33px] h-[33px] bg-white rounded-full p-1"
                  />
                </a>
              )}
              {organizationData?.telegram && (
                <a
                  href={organizationData.telegram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-2 text-white hover:text-blue-400"
                >
                  <FaTelegram size={28} />
                </a>
              )}
              {organizationData?.youtube && (
                <a
                  href={organizationData.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-2 text-white hover:text-red-500"
                >
                  <AiFillYoutube size={28} />
                </a>
              )}
            </div>
          </div>

          {/* Footer Links & Contact Information */}
          <div className="mt-6 lg:mt-0 lg:flex-1 ">
            <div className="grid grid-cols-3  sm:grid-cols-2">
              {/* Information Links */}
              <div>
                <h3 className="text-white text-2xl uppercase font-bold">
                  তথ্য সমূহ
                </h3>
                {footerData.map((footer) => (
                  <a
                    key={footer.id}
                    href={
                      footer.link.startsWith("http")
                        ? footer.link
                        : `https://${footer.link}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block mt-2 text-xl text-white hover:underline"
                  >
                    {footer.icon && (
                      <img
                        src={footer.icon}
                        alt="icon"
                        className="w-6 h-6 inline-block rounded-full mr-2"
                      />
                    )}
                    <span>{footer.title}</span>
                  </a>
                ))}
              </div>

              {/* Contact Information */}
              <div className="flex flex-col col-span-2 sm:col-span-1 ">
                <h3 className="text-white text-2xl uppercase font-bold">
                  যোগাযোগ
                </h3>
                {organizationData?.email && (
                  <p className="block mt-2 text-xl text-white">
                    <IoMailOutline size={20} className="inline-block" />
                    <a
                      href={`mailto:${organizationData.email}`}
                      className="ml-2 hover:underline"
                    >
                      {organizationData.email}
                    </a>
                  </p>
                )}
                {organizationData?.contact_no && (
                  <p className="block mt-2 text-xl text-white">
                    <FaPhoneAlt size={18} className="inline-block" />
                    <a
                      href={`tel:${organizationData.contact_no}`}
                      className="ml-2 hover:underline"
                    >
                      {organizationData.contact_no}
                    </a>
                  </p>
                )}
                {organizationData?.whatsapp && (
                  <p className="block mt-2 text-xl text-white">
                    <FaWhatsapp size={20} className="inline-block" />
                    <a
                      href={`${organizationData.whatsapp}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ml-2 hover:underline"
                    >
                      WhatsApp
                    </a>
                  </p>
                )}
                {organizationData?.address && (
                  <p className=" mt-2 text-xl text-white flex items-start">
                    <IoLocationOutline size={20} className="inline-block" />
                    <span className="ml-2">{organizationData.address}</span>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="py-5 border-t">
          <p className="text-center text-xl text-white">
             {organizationData?.id === 4 ? (
              <>
                Copyright © Medilogy Admission Care. All rights reserved{" "}
                {new Date().getFullYear()}
              </>
            
            ) : (
              <> Designed  &amp; Developed  By
                <a
                  href="https://aapedtech.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-blue-300"
                >
                  AAPEdtech
                </a>
                (Complete Solution)
              </>
            )}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
